module.exports = __webpack_public_path__ + "img/whiteArrow.81ccd6e2.svg";